import { render, staticRenderFns } from "./EditDialog_Comments.vue?vue&type=template&id=eae2bb2e"
import script from "./EditDialog_Comments.vue?vue&type=script&lang=js"
export * from "./EditDialog_Comments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports